import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";

import { useMediaQuery } from "react-responsive";
import { useDispatch, useSelector } from "react-redux";
import BankSelection from "../children/BankSelection";
import { requestToWithdrawAmount } from "../../../../redux/action/wallet";
import { ClipLoader } from "react-spinners";
import { notifyError } from "../../../../helpers/helpers";
function MoneyTransfer() {
  const isTablet = useMediaQuery({ query: "(max-width: 550px)" });
  const dispatch = useDispatch()

  const [soreBankDetail, setStoreBankDetail] = useState(null);
  const [veiwBalace, setVeiwBalace] = useState(false);
  const navigate = useNavigate();
  const { wallet, withdrawLoading } = useSelector((state) => state.wallet);

  const { bankDetail } = useSelector(
    (state) => state?.addMoneyToWallet
  );

  useEffect(() => {
    if (!bankDetail?.accountNo) {
      navigate("/wallet/add-money")
    }
  }, [bankDetail, navigate])

  return (
    <div className="">
      <span className="valign-wrapper gap-1">
        <img
          src={`${process.env.PUBLIC_URL}/icons/arrow_back.svg`}
          alt="Icon"
          className="pointer"
          onClick={() => navigate("/wallet/add-money")}
        />
        <h4>Withdraw money from wallet</h4>
      </span>

      <div className={`flex justify-center ${isTablet ? "mt-2" : "mt-4"}`}>
        <div style={{ minWidth: "40%" }}>
          <div className="cover white z-depth-2">
            <p className=" font-20px" style={{ padding: "1.5rem" }}>
              Transfer from wallet
            </p>
            <hr />
            <div
              className="valign-wrapper space-between"
              style={{ padding: "1.5rem" }}
            >
              <span className="valign-wrapper gap-1">
                <img
                  className="circle border purple lighten-4"
                  style={{ padding: "9px" }}
                  src={`${process.env.PUBLIC_URL}/icons/wallet-2.svg`}
                  alt="Icon"
                />

                <span>
                  <b className="font-18px">Your wallet</b>
                  <p
                    className={`cercle-purple-text font-16px ${veiwBalace ? "" : "text-decoration-underLine"
                      } pointer`}
                    style={{ marginTop: "-5px" }}
                    onClick={() => setVeiwBalace((pre) => !pre)}
                  >
                    {veiwBalace ? wallet?.availableBalance : "View balance"}
                  </p>
                </span>
              </span>
              <span className="material-icons-outlined mr-1 cercle-purple-text">
                check_circle
              </span>
            </div>
          </div>
          <div className="cover white z-depth-2 mt-2">
            <div className="valign-wrapper space-between">
              <p className=" font-20px" style={{ padding: "1.5rem" }}>
                Transfer to
              </p>
              <button
                className={`button-style bold pointer border-1px mr-2`}
                style={{ padding: "7px 25px" }}
                onClick={() => navigate("/wallet/add-money")}
              >
                Change
              </button>
            </div>
            <hr />
            <BankSelection
              bankDeatils={bankDetail}
              checkValue={true}
              setStoreBankDetail={setStoreBankDetail}
            />
          </div>

          <div
            className={`cover white z-depth-2 mt-2  ${isTablet ? "p-2" : "p-3"
              }`}
          >
            <div className="flex justify-center mb-2">
              <span
                className="material-icons-outlined select-wrapper circle purple lighten-4 cercle-purple-text"
                style={{
                  zIndex: "2",
                  left: "3%",
                  padding: "7px",
                  border: "1px solid purple",
                }}
              >
                account_balance
              </span>
              <img
                className="circle"
                style={{ padding: "7px", border: "1px solid purple" }}
                src={`${process.env.PUBLIC_URL}/icons/wallet-2.svg`}
                alt="Icon"
              />
            </div>
            <Formik
              initialValues={{
                amount: "",
              }}
              validationSchema={Yup.object().shape({
                amount: Yup.string().required("Amount is required"),
                //   password: Yup.string()
                //     .required("Password is required")
                //     .matches(/^\S*$/, "Password cannot contain spaces"),
              })}
              onSubmit={(values, { setSubmitting }) => {
                dispatch(requestToWithdrawAmount({ withDrawalAmount: `${values?.amount}`, bankAccount: bankDetail?._id }, navigate));
              }}
            >
              {({ isSubmitting }) => (
                <Form>
                  <div className="valign-wrapper column mt-1 gap-1">
                    <div style={{ width: isTablet ? "100%" : "450px" }}>
                      <label className="font-16px black-text">
                        Enter Amount to withdraw <span className="red-text">*</span>
                      </label>
                      <Field
                        className="input-tag-style"
                        type="number"
                        name="amount"
                        style={{ height: "2.5rem" }}
                      />
                      <ErrorMessage
                        name="amount"
                        component="div"
                        className="error-message red-text mb-1"
                        style={{ marginTop: "1px", fontSize: "12px" }}
                      />

                      {/* <label className="font-16px black-text">
                        Password <span className="red-text">*</span>
                      </label>
                      <Field
                        className="input-tag-style "
                        type={`${checkValue ? "text" : "password"}`}
                        name="password"
                        style={{ height: "2.5rem", marginBottom: "-7px" }}
                      />

                      <span
                        className="material-icons-outlined select-wrapper pointer"
                        style={{ bottom: "25px", right: "-95%" }}
                        onClick={() => setCheckValue((pre) => !pre)}
                      >
                        {checkValue ? "visibility" : "visibility_off"}
                      </span>
                      <ErrorMessage
                        name="password"
                        component="div"
                        className="error-message red-text marginTop--15px mb-1"
                        style={{ marginBottom: "15px", fontSize: "12px" }}
                      /> */}
                    </div>

                    <button
                      className="button-style white-text cercle-purple pointer "
                      style={{ padding: "12px 45px" }}
                    >
                      {withdrawLoading ? <ClipLoader color="red" size={20} /> : "Submit"}
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MoneyTransfer;
